'use strict';

require('es5-shim');
require('es5-shim/es5-sham');

require('./es2015');
